
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useDispatch } from "react-redux";
import { deleteAccount, getAccounts } from "../../store/slices/AcountsSlice";
import TableLoading from "../../components/Shared/TableLoading";
import CustomTreeTable from "../../components/Shared/CustomTreeTable";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/Shared/ConfirmationModal";
import { FiTrash2 } from "react-icons/fi";
import {
  AddIcon,
  DeleteIcon,
  EditIcon,
  EyeIcon,
} from "../../components/Shared/TableActionIcons";

export default function AccountsTable({ data, activeTab, loading }) {
  const lang = i18next.language;
  const { t, i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";
  const [confirmationDialogVisible, setConfirmationDialogVisible] =
    useState(false);
  const dispatch = useDispatch();
  const [deleteData, setDeleteData] = useState(null);
  const navigate = useNavigate();
  const handleDeleteAccount = () => {
    dispatch(deleteAccount(deleteData?.data?.id)).then(() => {
      dispatch(getAccounts({ account_type: activeTab }));
    });
    setConfirmationDialogVisible(false);
    setDeleteData(null);
  };
  const accountName = isRTL
    ? deleteData?.data?.name_code_ar
    : deleteData?.data?.name_code_en;


  const templateBody = (rowData) => {
    return (
      <div className="flex gap-1">
        <EyeIcon
          onClick={() =>
            navigate("/manager/accounts/view", {
              state: { account: rowData?.data || rowData },
            })
          }
          title={t("view")}
          className="text-primary"
        />

        <EditIcon
          title={t("edit")}
          onClick={() => {
            navigate("/manager/accounts/create", {
              state: { updateData: rowData?.data },
            });
          }}
        />
        <DeleteIcon
          onClick={() => {
            setConfirmationDialogVisible(true);
            setDeleteData(rowData);
          }}
          title={t("delete")}
        />
        <AddIcon
          onClick={() => {
            navigate("/manager/accounts/create", {
              state: { parentAccountData: rowData?.data },
            });
          }}
          title={t("add_sub_account")}
        />

      </div>
    );
  };

  const columnsData = [
    {
      body: templateBody,
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      header: t("actions"),
    },
    {
      // field: lang === 'ar' ? 'name_code_ar' : 'name_code_en',
      header: t("name"),
      headerCellClass: "!w-[40%]",
      bodyCellClass: "!w-[40%]",
      body: (rowData) => {
        const nameCodeField =
          lang === "ar"
            ? rowData?.data?.name_code_ar
            : rowData?.data?.name_code_en;
        const nameField =
          lang === "ar" ? rowData?.data?.name_ar : rowData?.data?.name_en;
        const code = rowData?.data?.code;

        // If name_code field is empty, construct it from code and name
        const displayName =
          nameCodeField ||
          (code && nameField ? `${code}-${nameField}` : nameField || "");

        return (
          <span>
            {displayName}{" "}
            {rowData?.data?.is_head && (
              <span className="ms-4 bg-primary/20 px-2 text-sm rounded-full text-primary">
                {"Head"}
              </span>
            )}
          </span>
        );
      },
      expander: true,
    },
    {
      field: lang === "ar" ? "type_ar" : "type_en",
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      header: t("type"),
    },
    {
      field: lang === "ar" ? "sub_type_ar" : "sub_type_en",
      headerCellClass: "!w-[15%]",
      bodyCellClass: "!w-[15%]",
      header: t("subType"),
    },

  ];

  return (
    <div>
      <CustomTreeTable
        data={data}
        isLoading={loading}
        loadingIcon={<TableLoading />}
        columns={columnsData}
        stateKey="account-table"
        stateStorage="local"
        columnResizeMode="expand"
        emptyMessage={
          <div className="text-center w-full py-4 text-gray-500">
            {t("No user found")}
          </div>
        }
        pt={{
          wrapper: { className: "overflow-auto" },
          table: { className: "min-w-[50rem]" },
        }}
        filterMode={"lenient"}
      />
      <ConfirmationModal
        visible={confirmationDialogVisible}
        setVisible={setConfirmationDialogVisible}
        header="delete_confirmation"
        message={t("delete_confirmation_popup_acc", { number: accountName })}
        acceptLabel="Delete"
        rejectLabel="Cancel"
        onAccept={handleDeleteAccount}
        onReject={() => setConfirmationDialogVisible(false)}
        Icon={FiTrash2}
      />
    </div>
  );
}
